import React from 'react';

import { useAtomValue } from 'jotai';

import { toastAtom } from '@smart-tv/atoms';
import { SuccessIcon } from '@smart-tv/components/icons/toast-icons/success-icon';
import { FailureIcon } from '@smart-tv/components/icons/toast-icons/failure-icon';

import styles from './toast.module.scss';
import { IconTypes } from '@smart-tv/hooks/use-toast/use-toast';

export const TOAST_DURATION_MS = 2500;

export const Toast = () => {
  const toast = useAtomValue(toastAtom);
  const [visible, setVisible] = React.useState(false);
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  React.useEffect(() => {
    if (toast == null) return;

    setVisible(true);

    if (timeoutRef.current != null) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setVisible(false);
    }, TOAST_DURATION_MS);

    return () => {
      if (timeoutRef.current != null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [toast]);

  if (toast == null) return null;

  const icon = (() => {
    switch (toast.iconType) {
      case IconTypes.success:
        return <SuccessIcon size={false} className={styles['toast--icon']} />;
      case IconTypes.failure:
        return <FailureIcon size={false} className={styles['toast--icon']} />;
      default:
        return null;
    }
  })();

  return (
    <div
      className={`${styles.toast} ${visible ? styles['toast--visible'] : styles['toast--hidden']}`}
    >
      {icon}
      <span className={styles['toast--message']}>{toast.message}</span>
    </div>
  );
};

export default Toast;
